import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";

import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { Icon } from "@/components/Icon/Icon";

import {
	closeHelpPanel,
	helpCenterSelector,
	openHelpPanel,
} from "@/pages/Private/redux/helpCenter/helpCenter.slice";

/**
 * The question-mark icon button itself — a compact header affordance that toggles the help chat.
 * Open state lives in the helpCenter slice so other surfaces can open the chat too, and so the
 * single `HelpPanelHost` can render the panel no matter which launcher was clicked.
 */
export const HelpLauncherButton: FunctionComponent = () => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const { isPanelOpen } = useAppSelector(helpCenterSelector);

	return (
		<button
			aria-label={t("helpCenter.launcher")}
			className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg text-base text-text-meta transition-colors duration-150 hover:bg-gray-100 hover:text-blue-action"
			title={t("helpCenter.launcher")}
			type="button"
			onClick={() => dispatch(isPanelOpen ? closeHelpPanel() : openHelpPanel())}
		>
			<Icon icon={faCircleQuestion} />
		</button>
	);
};
